// extracted by mini-css-extract-plugin
export var wrapper = "Layout-module--wrapper--nqe-A";
export var main = "Layout-module--main--1VYZl";